import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/display/loading-and-empty-states/loading-and-empty-states.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
